import React, { useState } from "react";
import "../styles/login.css";

const AdminLogin = () => {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setIsSubmitting(true);

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Login successful:", data);
        // Redirect to the admin dashboard after successful login
        window.location.href = "/admin/dashboard";
      } else {
        setErrorMsg(data.message || "Invalid email or password");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    console.log("Reset link requested for:", forgotEmail);
    // TODO: Add your forgot password API here
  };

  return (
    <div className="adminlogin-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="adminlogin-left">
        <div className="adminlogin-logo">
      <img
            src="/assets/Admin_log_img.png"
            alt="Inypeople Logo"
            className="adminlogin-logo-img"
            />
        </div>

        <div className="adminlogin-illustration">
          <img src="/assets/Admin_login_img.png" alt="Inypeople" />
        </div>

        <div className="adminlogin-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="adminlogin-right">
        {view === "login" ? (
          <form className="adminlogin-form" onSubmit={handleLoginSubmit}>
            <h1 className="adminform-heading">Admin Login</h1>

            <p className="adminform-subheading">
              Enter your credentials to access the admin dashboard
            </p>

            {errorMsg && (
              <p className="adminform-error" style={{ color: "red", marginBottom: "12px" }}>
                {errorMsg}
              </p>
            )}

            <label className="adminform-label">User Email ID</label>

            <input
              type="email"
              name="email"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={loginData.email}
              onChange={handleLoginChange}
              required
            />

            <label className="adminform-label">Password</label>

            <div className="adminpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="adminform-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
              <img
                src="/assets/Admin_log_eye.png"
                alt="Toggle password visibility"
                className="adminpassword-eye-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>

            <button
              type="button"
              className="adminlink-btn adminforgot-link"
              onClick={() => setView("forgot")}
            >
              Forgot Password?
            </button>

            <button type="submit" className="adminprimary-btn" disabled={isSubmitting}>
              {isSubmitting ? "SIGNING IN..." : "SIGN IN"}
            </button>
          </form>
        ) : (
          <form className="adminlogin-form" onSubmit={handleForgotSubmit}>
            <h1 className="adminform-heading">Forgot Password?</h1>

            <p className="adminform-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="adminform-label">User Email ID</label>

            <input
              type="email"
              name="forgotEmail"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            <button
              type="button"
              className="adminlink-btn adminback-link"
              onClick={() => setView("login")}
            >
              <div className="adminback-link-content">
            <img
                src="/assets/Admin_log-arrow.png"
                alt="Back"
                className="adminback-arrow"
            />
            <span>Back to Login</span>
            </div>
            </button>

            <button type="submit" className="adminprimary-btn">
              Send Reset Link
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;